<template>
  <div id="vue-app" class="vue-app">
    <div style="padding: 0 12px 12px 12px">
      <div class="title">户基本信息</div>
      <div class="card">
        <div class="card-item border-b">
          <span class="label">行政区划</span>
          <span class="content">{{ departName }}</span>
        </div>
        <div class="card-item border-b">
          <span class="label">户编号</span>
          <span class="content">{{ obj.houseNumber }}</span>
        </div>
        <div class="card-item">
          <span class="label">户籍地址</span>
          <span class="content">{{ obj.address }}</span>
        </div>
      </div>

      <div class="title">成员信息</div>
      <div>
        <rk-card v-if="list.length > 0" :list="list" :houseNumber="houseNumber" @delete="deleteIndex"></rk-card>
        <van-empty v-else style="width: 100%" description="暂无成员信息" ></van-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import rkCard from '@/views/common/rk-card.vue'
export default {
  components: { rkCard },
  data() {
    return {
      obj: {},
      dataList: [],
      params: this.$route.query,
      houseNumber: '',
      ifEdit: false,
      showTag: false,
      list: [],
      departName: '',
    }
  },
  created() {
    // let userInfo = JSON.parse(localStorage.getItem('sysUser'))
    // this.departName = userInfo.orgCodeTxt
    this.getData()
    this.getList()
  },
  mounted() {
    this.houseNumber = this.params.houseNumber
  },
  methods: {
    noPassName(str) {
      var tempStr = ''
      var len = str.length
      var firstStr = str.substr(0, 1)
      var middleStr = str.substring(1, len).replace(/[\s\S]/gi, '*')
      tempStr = firstStr + middleStr
      return tempStr
    },
    clickBack() {
      this.$router.go(-1)
    },
    getData() {
      getAction('/yqfk/hsxx/app/house/view', { houseNumber: this.params.houseNumber }).then((res) => {
        if (res.success) {
          let obj = res.result
          this.obj = obj
        }
      })
    },
    getList() {
      getAction('/yqfk/hsxx/app/person/lsit', { houseNumber: this.params.houseNumber }).then((res) => {
        if (res.success) {
          let list = res.result
         list.map((obj,index) => {
            obj.sfbd = obj.sfbdcz == '1' ? true : false
            obj.sfhs = obj.sfcyqyhs == '1' ? true : false
            if (obj.appTag) {
              obj.appTags = item.appTag.split('，')
            }
            if(obj.houseRelation=='02'){//将02插入数组第一个
                list.unshift(list.splice(index , 1)[0]);
            }

            return obj
          })
          this.list = list
        }
      })
    },
    deleteIndex(index) {
      this.list.splice(index, 1)
    },
  },
}
</script>

<style scoped lang="less">
.vue-app {
  min-height: 100vh;
  background: #f6f6f6;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  padding-top: 10px;
}

.card {
  background: #fff;
  border-radius: 5px;
  margin-bottom: 5px;
  box-shadow: 0px 1px 8px 0 rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  padding: 0 10px;
  margin-top: 10px;

  .border-b {
    border-bottom: 1px solid #dedede;
  }

  .card-item {
    display: flex;
    font-size: 14px;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px 0;

    .label {
      width: 65px;
      color: #303133;
    }

    .content {
      flex: 1;
      text-align: right;
      color: #606266;
    }
  }
}

.img-empty {
  width: 50%;
  margin-left: 25%;
}
</style>